import React, { createContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import ListingServices from '../Services/Consumers/ListingServices'
import { filterData, handleNotificationAlert } from '../utils/helpers'
import { useKeycloak } from '@react-keycloak/web'
import Configuration from '../Services/Api/Configuration'
import moment from 'moment'

const DraftInvoiceSubmitContext = createContext({})

const DraftInvoiceSubmitProvider = ({ children, updateParentEntity, invoices, updateSelectedRows }) => {
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [invoiceSubmissionLoading, setInvoiceSubmissionLoading] = React.useState(false)

  const signInvoice = (certificateNumber, closeDialog) => {
    if (!!keycloak?.authenticated && !!invoices.length && !!certificateNumber) {
      setInvoiceSubmissionLoading(true)
      let signedInvoices = []
      invoices?.forEach((invoice, index) => {
        let currentInvoice = filterData(invoice?.document, false, true)
        if (currentInvoice?.receiver?.type === 'P' && !currentInvoice?.receiver?.id) {
          currentInvoice.receiver.id = ''
        }
        if (['EI', 'EC', 'ED'].includes(currentInvoice?.documentType)) {
          currentInvoice.serviceDeliveryDate = currentInvoice.serviceDeliveryDate ? moment(currentInvoice.serviceDeliveryDate).locale('en-us').format('YYYY-MM-DD') : moment().locale('en-us').format('YYYY-MM-DD')
        } else {
          currentInvoice.invoiceLines?.map(lineItem => {
            delete lineItem.weightQuantity
            delete lineItem.weightUnitType
            return lineItem
          })
        }
        // if (currentInvoice?.documentTypeVersion?.toString() === '1.0') {
        ListingServices.signInvoices({
          'certificateSerialNumber': certificateNumber,
          'contentToSign': Buffer.from(JSON.stringify(currentInvoice)).toString('base64')
        }, setInvoiceSubmissionLoading, null, intl.formatMessage({ id: 'invoice.signing.error' })).then((result) => {
          if (!!result && !!result.data && !!result.data.signature) {
            let submissionObject = currentInvoice
            if (!!result.data.signature && submissionObject?.documentTypeVersion?.toString() === '1.0') {
              submissionObject.signatures = [{
                signatureType: 'I',
                value: result.data.signature
              }]
            }
            signedInvoices.push(submissionObject)
          }
        }).then(() => {
          if (index === invoices?.length - 1 && signedInvoices.length === invoices.length) {
            handleNotificationAlert({
              type: 'done',
              message: intl.formatMessage({ id: 'Invoice.sign.Done' }),
              color: 'success'
            }, 'success')
            setTimeout(() => submitInvoice(signedInvoices, closeDialog), 100)
          }
        })
        // } else {
        //   signedInvoices.push(currentInvoice)
        // }
      })
    }
  }

  const submitInvoice = (signedInvoices, closeDialog) => {
    if (!!keycloak?.authenticated && !!signedInvoices.length) {
      setInvoiceSubmissionLoading(true)
      ListingServices.submitInvoices({ documents: signedInvoices },
        { headers: { serviceId: Configuration.HEADER_SERVICE_ID } }, setInvoiceSubmissionLoading,
        null, intl.formatMessage({ id: 'invoice.submit.error' })).then((result) => {
        if (!!result && !!result.data && !!result.data.submissionId) {
          handleNotificationAlert({
            type: 'done',
            message: intl.formatMessage({ id: 'Invoice.sign.Done' }),
            color: 'success'
          }, 'success')
          if (!!updateParentEntity) {
            updateParentEntity(true, () => updateSelectedRows(invoices?.map(invoice => invoice.id)))
          }
        } else if (result?.data?.rejectedDocuments?.length) {
          let message = <FormattedMessage id='invoice.submit.error'/>
          let messagesList = []
          if (result.data?.rejectedDocuments[0]?.error?.details?.length) {
            result.data?.rejectedDocuments[0]?.error?.details.forEach(msg => {
              messagesList.push(<>
                <strong>{`${!!msg.code ? msg.code : result.data?.rejectedDocuments[0]?.error?.code || ''} ${!!msg.target ? `(${msg.target})` : ''}`}:</strong> {msg.message}</>)
            })
          } else {
            if (result?.data?.rejectedDocuments[0]?.error?.message) {
              message = result.data?.rejectedDocuments[0]?.error?.message
            }
          }
          if (!!messagesList?.length) {
            messagesList.forEach(msg => {
              handleNotificationAlert({
                type: 'defence',
                message: msg,
                color: 'error'
              }, 'error')
            })
          } else {
            handleNotificationAlert({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
          }
          if (!!updateParentEntity) {
            updateParentEntity(false)
          }
        }
      }).then(() => {
        setInvoiceSubmissionLoading(false)
      })

    }
  }

  return (
    <DraftInvoiceSubmitContext.Provider value={{
      invoiceSubmissionLoading,
      submitInvoice,
      signInvoice
    }}>
      {children}
    </DraftInvoiceSubmitContext.Provider>
  )
}
const DraftInvoiceSubmitConsumer = DraftInvoiceSubmitContext.Consumer

export { DraftInvoiceSubmitProvider, DraftInvoiceSubmitConsumer }
